import "./styles/App.css";

import Navbar from "./components/Navbar/Navbar";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import headerImg from "../src/assets/home-header.png";
import AccomodationSection from "./components/AccommodationSection/AccomodationSection";

import accomodationFactory from "./factories/AccomodationFactory";
import React, { useEffect, useState } from "react";

function App() {
  document.title = "Kasa - Accueil";

  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [accomodations, setAccomodations] = useState([]);

  useEffect(() => {
    fetch("./data/accomodations.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => {
        return response.json();
      })
      .then(
        (data) => {
          setIsLoaded(true);
          let accomodationData = data.map((accomodation) => {
            return new accomodationFactory(accomodation, "json");
          });
          setAccomodations(accomodationData);
        },

        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      );
  }, []);

  if (error) {
    return <div>Error:{error.message}</div>;
  } else if (!isLoaded) {
    return <div>Loading...</div>;
  } else {
    return (
      <div className="App">
        <Navbar route="home" />
        <main>
          <Header
            imageSource={headerImg}
            title={
              <p>
                Chez vous,
                <br className="hide-desktop" />
                partout et ailleurs
              </p>
            }
          />
          <AccomodationSection accomodations={accomodations} />
        </main>
        <Footer />
      </div>
    );
  }
}

export default App;
